/* eslint-disable no-console */
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SecurityDetailsResponse } from '../models/security-details'

const SECURITY_DETAILS_URL = 'helios-pricing/accounts'
@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(private readonly httpClient: HttpClient) {}

  getSecurityDetails(
    accountId: number,
    securityId: number,
  ): Observable<SecurityDetailsResponse> {
    return this.httpClient.get<SecurityDetailsResponse>(
      `${SECURITY_DETAILS_URL}/${accountId}/securities/${securityId}/details`,
    )
  }
}
